
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class FormItem extends Vue {
  @Prop({ type: String, required: true }) readonly label!: string;
  @Prop({ type: Boolean }) readonly date!: boolean;
}
